<template>
  <div>
    <quill-editor
      v-show="!isEditingPlainText"
      class="full-height"
      ref="quillEditor"
      :options="_quillOptions"
      :value="value"
      @input="$emit('input', $event)">
    </quill-editor>
    <textarea
      v-if="isEditingPlainText"
      class="textarea input full-height"
      maxlength="670"
      v-model="plainText"
    >
    </textarea>
  </div>
</template>

<script>
import DiffMatchPatch from 'diff-match-patch'

export default {
  name: 'WYSIWYGAndPlainTextEditer',
  props: {
    // v-modelによるバインド
    value: {
      type: String,
      required: false,
    },
    isEditingPlainText: {
      type: Boolean,
      required: false,
      default: false
    },
    quillOptions: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      quill: undefined,
      plainText: '',
      plainTextOld: '',
    }
  },
  mounted() {
    this.quill = this.$refs.quillEditor.quill
    this.updatePlainText()
  },
  watch: {
    value() {
      this.updatePlainText()
    },
    plainText() {
      // diffの計算
      const dmp = new DiffMatchPatch()
      const diffs = dmp.diff_main(this.plainTextOld, this.plainText)
      this.plainTextOld = this.plainText

      this.updateHTML(diffs)
    }
  },
  computed: {
    _quillOptions() {
      const defaultOptions = {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      }
      return this.quillOptions || defaultOptions
    }
  },
  methods: {
    updatePlainText() {
      this.plainText = this.quill.getText().slice(0, -1)
      this.plainTextOld = this.plainText
    },
    updateHTML(diffs) {
      let index = 0
      for (let d of diffs) {
        if (d[0] == 0) {
          // equality
          index += d[1].length
        }
        else if (d[0] == 1) {
          // insertion
          this.quill.insertText(index, d[1])
          index += d[1].length
        }
        else if (d[0] == -1) {
          // deletion
          this.quill.deleteText(index, d[1].length)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .wrapper {
    position: relative;
  }
  .full-height {
    height: 100%;
    overflow-y: scroll;
  }
  .full-height::-webkit-scrollbar {
    width:  5px;
    height: 5px;
    visibility: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/ui/WYSIWYGAndPlainTextEditer.vue